import {CHANNEL_TYPE} from "@/enums/ai";
import {GAILGPT_USER_DEFAULT_ASSISTANT_KEY} from "@/utils/common/constants/userProfile";

type ProfileShape = {
   favorites?: Record<string, string[]>;
};

/**
 * Returns the assistant id the user has chosen as their personal default
 * for the chat dropdown, or undefined if none is set.
 *
 * Scoped to the GPT channel: SMS and other channels keep using the
 * org-level default. When a non-GPT channel is requested this returns
 * undefined so callers fall through to the org default.
 *
 * Stored as a single-element string[] under the favorites map to fit the
 * existing user-profile shape without requiring a backend migration.
 */
export const getUserDefaultAssistantId = (
   profile: ProfileShape | undefined,
   channelType: CHANNEL_TYPE | undefined,
): string | undefined => {
   if (channelType !== CHANNEL_TYPE.GPT) return undefined;
   return profile?.favorites?.[GAILGPT_USER_DEFAULT_ASSISTANT_KEY]?.[0];
};
